import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';

import common from './modules/common.js';
import indexCar from './modules/car/indexCar.js';
import indexHotel from './modules/hotel/indexHotel.js';
import indexTrain from './modules/train/indexTrain.js';
import hotelWriteOrder from './modules/hotel/writeOrder.js';
import hotelDetail from './modules/hotel/detail.js';
import temporary from './modules/temporary.js';
import config from './modules/config.js';
// 机票
import flightWriteOrder from './modules/flight/writeOrder.js';
import flightCommon from './modules/flight/flightCommon.js';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loading: false,
    loadingtext: '加载中...',
  },
  modules: {
    common,
    indexCar,
    indexHotel,
    indexTrain,
    hotelWriteOrder,
    hotelDetail,
    flightWriteOrder,
    flightCommon,
    temporary,
    config,
  },
  mutations: {
    switch_loading(state, tf) {
      if (!tf || tf.show == undefined) {
        state.loading = true;
      } else if (tf && tf.show != undefined) {
        state.loading = tf.show;
      } else {
        state.loading = !state.loading;
      }
      state.loadingtext = '加载中...';
      if (tf && tf.text) {
        state.loadingtext = tf.text;
      }
    },
  },
  actions: {},
  plugins: [
    createPersistedState({
      paths: ['common', 'indexCar', 'indexHotel', 'indexTrain', 'flightWriteOrder', 'config'],
      // 传入参数
      storage: {
        getItem: (key) => uni.getStorageSync(key),
        setItem: (key, val) => uni.setStorageSync(key, val),
        removeItem: (key) => uni.removeStorageSync(key),
      },
    }),
  ],
  getters,
});

export default store;
